import React from "react"
import styled from "@emotion/styled"


const Title = styled.a`
    margin: 0;
    font-size: 3rem;
    color: #000000FF;
    text-decoration: none;
    cursor: pointer;
    font-family: Tango;
    -webkit-transition: all 300ms linear 0s;
    -o-transition: all 300ms linear 0s;
    transition: all 300ms linear 0s;
    padding-top: 2rem;

    &:hover {
        color: #f80c16;
    }

    @media (max-width: 769px) {
        font-size: 2.25rem;
    }

    @media (max-width: 320px) {
        font-size: 1.9rem;
    }
`

const Brand = () => {
  return (
    <Title href="/">
        Alexandra Thomas
    </Title>
  )
}

export default Brand